import axios from "axios";

const experiment = axios.create({
    baseURL: process.env.VUE_APP_TMS_SERVER,
    timeout: 30000,
    withCredentials: true
});
experiment.defaults.headers['Product'] = 'vsp';

experiment.interceptors.request.use(res => {
    res.headers["token"] = JSON.parse(localStorage.getItem("USER")) ? JSON.parse(localStorage.getItem("USER")).token : '';
    return res;
})

experiment.interceptors.response.use(
    response => {
        if (response.data.errCode === 1) {
            window.$vm.$Message.error(response.data.errMsg);
            return Promise.reject(response.data);
        }

        return response.data;
    },

    error => {
        window.$vm.$Message.error(error.response.data.errMsg);
        return Promise.reject(error)
    }
);

export default {
    //讲师
    //删除实验 
    deleteExperiment(id) {
        return experiment.post(`/Experiment/delete/${id}`);
    },
    // 获取实验成绩
    getExperimentReport(params) {
        return experiment.post(`Experiment/getExperimentReport`, params);
    },
    // 查看实验信息
    queryExperiment(id) {
        return experiment.post(`/Experiment/info/${id}`);
    },
    // 发布实验
    addExperiment(params) {
        return experiment.post(`/Experiment/save`, params);
    },
    // 编辑实验
    updateExperiment(params) {
        return experiment.post(`/Experiment/update`, params);
    },
    // 获取本校实验列表
    getSchoolExperimentList(params) {
        return experiment.post(`/Experiment/schoolExperimentList`, params);
    },
    //获取上架的学科
    getShelvesTagList() {
        return experiment.post(`/Experiment/tag/getShelvesTagList`);
    },
    //获取学院列表  
    getCollegeList(params) {
        return experiment.post(`/collegeMgr/getCollegeList`, params);
    },
    //成绩分布统计  
    getExperimentScoreStatics(experimentId) {
        return experiment.post(`/Experiment/getExperimentScoreStatics/${experimentId}`);
    },
    //获取已导入学生列表
    getExperimentStudentList(id) {
        return experiment.post(`/Experiment/getExperimentStudentList/${id}`);
    },
    //实验成绩导出
    exportExperimentReport(params) {
        return experiment.get(`/Experiment/exportExperimentReport/${params.id}/${params.obligatory}`, {
            responseType: 'arraybuffer',
        });
    },
    //上下架实验  /Experiment/shelvesExperiment/{id}/{status}
    shelvesExperiment(params) {
        return experiment.post(`/Experiment/shelvesExperiment/${params.id}/${params.status}`);
    },

    //学生
    // 获取学科类别
    getExperimentKinds() {
        return experiment.post(`Experiment/getExperimentKinds`);
    },
    // 获取本校实验类别
    getSchoolExperimentKinds() {
        return experiment.post(`/Experiment/getSchoolExperimentKinds`);
    },
    //搜索全部实验
    queryAllExperiment(params) {
        return experiment.post(`/Experiment/queryExperiment`, params);
    },
    //搜索本校实验
    querySchoolExperiment(params) {
        return experiment.post(`/Experiment/querySchoolExperiment`, params);
    },
    //获取我的实验
    getMyExperiment(params) {
        return experiment.post(`/Experiment/getMyExperiment`, params);
    },
    //退出自修课  
    quitSelfStudy(experimentId) {
        return experiment.post(`/Experiment/quitSelfStudy/${experimentId}`);
    },
    //收藏实验 
    collect(id) {
        return experiment.post(`/Experiment/collect/${id}`);
    },
    //取消收藏实验 
    cancelCollect(id) {
        return experiment.post(`/Experiment/cancelCollect/${id}`);
    },
    //获取实验信息 
    getExperimentInfo(id) {
        return experiment.post(`/Experiment/getExperimentInfo/${id}`);
    },
    //点击开始实验 
    clickExperiment(id) {
        return experiment.post(`/Experiment/clickExperiment/${id}`);
    },
    //获取实验记录 
    getMyReport(experimentId) {
        return experiment.post(`/Experiment/getMyReport/${experimentId}`);
    },
    //公开实验
    publishExperiment(params) {
        return experiment.post(`/Experiment/publishExperiment/${params.id}/${params.status}`);      
    }
};